export const ensureXmlHeader = (xml: string) =>
   xml.trimStart().startsWith("<?xml") ? xml : `<?xml version="1.0" encoding="UTF-8"?>\n${xml}`;

export const downloadXml = (xml: string, filename = "document.xml") => {
   const blob = new Blob([xml], { type: "application/xml;charset=utf-8" });
   const url = URL.createObjectURL(blob);

   const a = document.createElement("a");
   a.href = url;
   a.download = filename;
   document.body.appendChild(a);
   a.click();

   a.remove();
   URL.revokeObjectURL(url);
};
